import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-c-input-filter',
  templateUrl: './c-input-filter.component.html',
  styleUrls: ['./c-input-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CInputFilterComponent)
    }
  ]
})
export class CInputFilterComponent implements ControlValueAccessor {
  @Input()
  label = ' ';

  @Input()
  placeholder: string | undefined = ' ';

  @Input()
  dropSpecial = false;

  @Input()
  disabled = false;

  @Input()
  value: string = '';

  @Input()
  required = false;

  @Input()
  inputMask: string | undefined = '';

  @Input()
  searchList: string[] = [];

  showFilter: boolean = true;

  constructor() {}

  onTouched = (): void => {};

  onChange = (value: string): void => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectItem(item: string): void {
    this.value = item;
    this.showFilter = false;
  }

  changeShowFilterTimeout(): void {
    setTimeout(() => {
      this.showFilter = false;
    }, 350);
  }
}
